import { render, staticRenderFns } from "./ReportSettingsLandlordSelector.vue?vue&type=template&id=28ab0830&"
import script from "./ReportSettingsLandlordSelector.vue?vue&type=script&lang=js&"
export * from "./ReportSettingsLandlordSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports